<template>
  <transition name="vertical-slide" appear>
    <div class="app-toast">
      <transition-group name="horizontal-slide" tag="div" appear>
        <div v-for="item in items"
             :key="item.id"
             class="app-toast__item"
             @click="$emit('remove-toast-item', item.id)">
          <div class="app-toast__item-message">{{ item.message }}</div>
          <button v-if="item.btnText" class="app-toast__item-btn"
                  @click.stop.prevent="item.btnFunc">
            {{ item.btnText }}
          </button>
        </div>
      </transition-group>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AppToast',
  props: {
    items: Array
  }
}
</script>

<style lang="scss" scoped>
.app-toast {
  z-index: 1;
  position: fixed;
  bottom: 0;
  left: 0;
}
.app-toast__item {
  @include clearfix;
  margin: 0 14px 14px;
  border-radius: 4px;
  padding: 14px;
  background-color: $black5;
  color: $white1;
}
.app-toast__item-btn {
  padding: 0;
  margin-top: 7px;
  border: 0;
  background-color: transparent;
  display: block;
  color: $orange2;
  float: right;
}
.horizontal-slide-enter,
.horizontal-slide-leave-to {
  opacity: 0;
}
</style>
